import React, { Fragment } from 'react';
import { EmptyStar, FullStar, HalfStar } from './star-rating-cell-styles';
import { Star } from './star-rating-types';
var StarRatingCell = function (_a) {
    var rating = _a.rating, CustomFullStar = _a.customFullStar, CustomEmptyStar = _a.customEmptyStar, CustomHalfStar = _a.customHalfStar;
    return (React.createElement(Fragment, null,
        rating === Star.FULL_STAR && (CustomFullStar ? React.createElement(CustomFullStar, null) : React.createElement(FullStar, null)),
        rating === Star.HALF_STAR && (CustomHalfStar ? React.createElement(CustomHalfStar, null) : React.createElement(HalfStar, null)),
        rating === Star.EMPTY_STAR && (CustomEmptyStar ? React.createElement(CustomEmptyStar, null) : React.createElement(EmptyStar, null))));
};
export default StarRatingCell;
